// src/services/homeApiService.js

const API_BASE_URL = 'https://apps.genus.in/GenOpsAPI/api';
//const API_BASE_URL = 'http://localhost:5134/api';


// ✅ Cookie sent automatically — no Authorization header needed
const defaultFetchOptions = {
  credentials: 'include',
  headers: { 'accept': '*/*' }
};

const homeApiService = {

  async getPCBProjects(serverId, forDate) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/PCB/live-projects/range?serverId=${serverId}&startDate=${forDate}&endDate=${forDate}`,
        { ...defaultFetchOptions }
      );
      if (!response.ok) throw new Error('Failed to fetch PCB projects');
      return await response.json();
    } catch (error) {
      console.error('Error fetching PCB projects:', error);
      throw error;
    }
  },

  async getEMAProjects(serverId, forDate) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/Setting/ProjectListDateRangeWise?serverID=${serverId}&FromDt=${forDate}&ToDate=${forDate}`,
        { ...defaultFetchOptions }
      );
      if (!response.ok) throw new Error('Failed to fetch EMA projects');
      return await response.json();
    } catch (error) {
      console.error('Error fetching EMA projects:', error);
      throw error;
    }
  },

  async getProjects(area, serverId, forDate) {
    if (area === 'PCB') return await this.getPCBProjects(serverId, forDate);
    if (area === 'EMA') return await this.getEMAProjects(serverId, forDate);
    return [];
  },

  async getPCBRunningLines(serverId, projCode, startDate, endDate) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/PCB/running-lines/range?serverId=${serverId}&projCode=${projCode}&startDate=${startDate}&endDate=${endDate}`,
        { ...defaultFetchOptions }
      );
      if (!response.ok) throw new Error('Failed to fetch PCB running lines');
      return await response.json();
    } catch (error) {
      console.error('Error fetching PCB running lines:', error);
      throw error;
    }
  },

  async getEMARunningLines(serverId, projCode, fromDt, toDt) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/Setting/RunningLines?serverId=${serverId}&projCode=${projCode}&fromDt=${fromDt}&toDt=${toDt}`,
        { ...defaultFetchOptions }
      );
      if (!response.ok) throw new Error('Failed to fetch EMA running lines');
      return await response.json();
    } catch (error) {
      console.error('Error fetching EMA running lines:', error);
      throw error;
    }
  },

  async getHourlyProduction(serverId, projCode, lineNumber, shift, startDate, endDate, area) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/Hourly/range?serverId=${serverId}&projCode=${projCode}&lineNumber=${lineNumber}&shift=${shift}&startDate=${startDate}&endDate=${endDate}&area=${area}`,
        { ...defaultFetchOptions }
      );
      if (!response.ok) throw new Error('Failed to fetch hourly production');
      const data = await response.json();
      return Array.isArray(data)
        ? data.reduce((sum, item) => sum + (item.totalCount || 0), 0)
        : 0;
    } catch (error) {
      console.error('Error fetching hourly production:', error);
      return 0;
    }
  },

  async getLineNumbers(projectCode, shift, area, serverId, startDate, endDate) {
    try {
      let lines = [];
      if (area === 'PCB') {
        lines = await this.getPCBRunningLines(serverId, projectCode, startDate, endDate);
      } else if (area === 'EMA') {
        lines = await this.getEMARunningLines(serverId, projectCode, startDate, endDate);
      }

      if (!Array.isArray(lines) || lines.length === 0) return [];

      const linesWithProduction = await Promise.all(
        lines.map(async (line, index) => {
          const totalProduction = await this.getHourlyProduction(
            serverId, projectCode, line.userId, shift, startDate, endDate, area
          );
          return {
            lineNo:          `Line ${index + 1} (${line.userName})`,
            userId:          line.userId,
            userName:        line.userName,
            totalProduction: totalProduction,
            lastSynced:      new Date().toLocaleString('en-IN', {
              day: '2-digit', month: 'short', year: 'numeric',
              hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
            })
          };
        })
      );

      return linesWithProduction;
    } catch (error) {
      console.error('Error in getLineNumbers:', error);
      return [];
    }
  }
};

export default homeApiService;



// // src/services/homeApiService.js

// //const API_BASE_URL = 'https://apps.genus.in/GenOpsAPI/api';
// const API_BASE_URL = 'http://localhost:5134/api';

// const homeApiService = {
//   // Get projects for PCB area
//   async getPCBProjects(serverId, forDate) {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/PCB/live-projects/range?serverId=${serverId}&startDate=${forDate}&endDate=${forDate}`,
//         { headers: { 'accept': '*/*' } }
//       );
//       if (!response.ok) throw new Error('Failed to fetch PCB projects');
//       return await response.json();
//     } catch (error) {
//       console.error('Error fetching PCB projects:', error);
//       throw error;
//     }
//   },

//   // Get projects for EMA area
// async getEMAProjects(serverId, forDate) {
//   try {
//     const response = await fetch(
//       `${API_BASE_URL}/Setting/ProjectListDateRangeWise?serverID=${serverId}&FromDt=${forDate}&ToDate=${forDate}`,
//       { headers: { accept: '*/*' } }
//     );
//     if (!response.ok) throw new Error('Failed to fetch EMA projects');
//     return await response.json();
//   } catch (error) {
//     console.error('Error fetching EMA projects:', error);
//     throw error;
//   }
// },

//   // Get projects based on area
// async getProjects(area, serverId, forDate) {
//   if (area === 'PCB') {
//     return await this.getPCBProjects(serverId, forDate);
//   } else if (area === 'EMA') {
//     return await this.getEMAProjects(serverId, forDate); // ✅ pass date
//   }
//   return [];
// },
//   // Get running lines for PCB
//   async getPCBRunningLines(serverId, projCode, startDate, endDate) {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/PCB/running-lines/range?serverId=${serverId}&projCode=${projCode}&startDate=${startDate}&endDate=${endDate}`,
//         { headers: { 'accept': '*/*' } }
//       );
//       if (!response.ok) throw new Error('Failed to fetch PCB running lines');
//       return await response.json();
//     } catch (error) {
//       console.error('Error fetching PCB running lines:', error);
//       throw error;
//     }
//   },

//   // Get running lines for EMA
//   async getEMARunningLines(serverId, projCode, fromDt, toDt) {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/Setting/RunningLines?serverId=${serverId}&projCode=${projCode}&fromDt=${fromDt}&toDt=${toDt}`,
//         { headers: { 'accept': '*/*' } }
//       );
//       if (!response.ok) throw new Error('Failed to fetch EMA running lines');
//       return await response.json();
//     } catch (error) {
//       console.error('Error fetching EMA running lines:', error);
//       throw error;
//     }
//   },

//   // Get hourly production data
//   async getHourlyProduction(serverId, projCode, lineNumber, shift, startDate, endDate, area) {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/Hourly/range?serverId=${serverId}&projCode=${projCode}&lineNumber=${lineNumber}&shift=${shift}&startDate=${startDate}&endDate=${endDate}&area=${area}`,
//         { headers: { 'accept': '*/*' } }
//       );
//       if (!response.ok) throw new Error('Failed to fetch hourly production');
//       const data = await response.json();
      
//       // Calculate total production
//       const totalProduction = Array.isArray(data) 
//         ? data.reduce((sum, item) => sum + (item.totalCount || 0), 0)
//         : 0;
      
//       return totalProduction;
//     } catch (error) {
//       console.error('Error fetching hourly production:', error);
//       return 0;
//     }
//   },

//   // Get line numbers with production data
//   async getLineNumbers(projectCode, shift, area, serverId, startDate, endDate) {
//     try {
//       let lines = [];
      
//       // Fetch running lines based on area
//       if (area === 'PCB') {
//         lines = await this.getPCBRunningLines(serverId, projectCode, startDate, endDate);
//       } else if (area === 'EMA') {
//         lines = await this.getEMARunningLines(serverId, projectCode, startDate, endDate);
//       }

//       if (!Array.isArray(lines) || lines.length === 0) {
//         return [];
//       }

//       // Fetch production data for each line
//       const linesWithProduction = await Promise.all(
//         lines.map(async (line, index) => {
//           const userId = line.userId;
//           const userName = line.userName;
          
//           // Fetch production count
//           const totalProduction = await this.getHourlyProduction(
//             serverId,
//             projectCode,
//             userId,
//             shift,
//             startDate,
//             endDate,
//             area
//           );

//           return {
//             lineNo: `Line ${index + 1} (${userName})`,
//             userId: userId,
//             userName: userName,
//             totalProduction: totalProduction,
//             lastSynced: new Date().toLocaleString('en-IN', { 
//               day: '2-digit', 
//               month: 'short', 
//               year: 'numeric',
//               hour: '2-digit',
//               minute: '2-digit',
//               second: '2-digit',
//               hour12: true 
//             })
//           };
//         })
//       );

//       return linesWithProduction;
//     } catch (error) {
//       console.error('Error in getLineNumbers:', error);
//       return [];
//     }
//   }
// };

// export default homeApiService;